<fgb-page-header [pageTitle]="'wallet.page.claimed.rewards'" [showBalance]="false"></fgb-page-header>
<div class="container">
  <div class="mb-3 d-none d-lg-flex">
    <div class="reward-back-btn cursor-pointer gloss-black" [routerLink]="'/rewards/wallet'">
      <i class="icon material-icons">arrow_back_ios_new</i>
    </div>
  </div>
  <!-- Offer history -->
  <ng-container *ngIf="campaignOffers$ | async as featuredCampaigns">
    <ng-container *ngIf="featuredCampaigns.CampaignsAndEntitlements?.length">
      <div class="mb-3">
        <h5 class="m-0 wallet-redeemed-title text-uppercase font-size-20 pb-2">
          {{ 'wallet.redeemed.offers.history.title' | translate }}
        </h5>
        <fgbcl-campaigns-offers-used-list
          [usedOffers]="featuredCampaigns.CampaignsAndEntitlements"
        ></fgbcl-campaigns-offers-used-list>
      </div>
    </ng-container>
  </ng-container>

  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <div>
        <h5 class="m-2 wallet-redeemed-title">{{ 'wallet.redeemed.title' | translate }}</h5>
        <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="walletItems.walletItemsClaimed"></fgbcl-rewards-wallet-redeemed-list>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="pt-1">
    <div class="font-size-12 text-center py-3 no-rewards-placeholder">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
